import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { getLiveApps, getComingSoonApps } from '../constants/apps';

const Hero = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { lang } = useParams();

    const liveCount = getLiveApps().length;
    const comingCount = getComingSoonApps().length;

    return (
        <header className="container" style={{ padding: 'var(--section-padding)', textAlign: 'center', position: 'relative' }}>
        <div className="animate-float">
            <h1 style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)', marginBottom: '30px', lineHeight: '1.2', fontWeight: '800' }}>
              {t('hero.title').split(t('hero.gradient'))[0]} <br />
              <span className="text-gradient">{t('hero.gradient')}</span>
            </h1>
        </div>
        <p style={{ fontSize: '1.4rem', color: 'var(--text-muted)', maxWidth: '800px', margin: '0 auto 40px' }}>
            {t('hero.subtitle')}
        </p>

        {/* Stats bar */}
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
            flexWrap: 'wrap',
            marginBottom: '40px',
            fontSize: '0.85rem',
            color: 'var(--text-muted)',
            fontWeight: 600,
            letterSpacing: '0.5px'
        }}>
            <span style={{ background: 'rgba(0,255,65,0.08)', padding: '6px 16px', borderRadius: '20px', border: '1px solid rgba(0,255,65,0.1)' }}>
                {liveCount} {t('hero.live_apps')}
            </span>
            <span style={{ background: 'rgba(0,229,255,0.08)', padding: '6px 16px', borderRadius: '20px', border: '1px solid rgba(0,229,255,0.1)' }}>
                {comingCount} {t('hero.coming_soon')}
            </span>
            <span style={{ background: 'rgba(213,0,249,0.08)', padding: '6px 16px', borderRadius: '20px', border: '1px solid rgba(213,0,249,0.1)' }}>
                {t('hero.private_local')}
            </span>
        </div>

        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => navigate(`/${lang}/apps`)} className="btn btn-primary" style={{ minWidth: '250px', padding: '15px 30px', fontSize: '1.1rem' }}>
              {t('hero.cta_primary')}
            </button>
            <button onClick={() => navigate(`/${lang}/benchmark`)} className="btn btn-secondary" style={{ minWidth: '250px', padding: '15px 30px', fontSize: '1.1rem' }}>
              {t('hero.cta_benchmark')}
            </button>
        </div>
        
        {/* Banner Image with Glow */}
        <div style={{ marginTop: '80px', position: 'relative' }}>
            <div className="glow-bg" style={{ top: '50%', transform: 'translateY(-50%)', height: '80%', background: 'radial-gradient(circle, rgba(213, 0, 249, 0.2) 0%, transparent 60%)' }}></div>
            <img 
                src="/assets/banner.jpg" 
                alt="NPU Universe Ecosystem Dashboard - Offline AI and Local NPU Acceleration Tools" 
                className="glass-card"
                style={{ 
                    maxWidth: '100%', 
                    borderRadius: '20px', 
                    padding: '10px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    position: 'relative',
                    zIndex: 1
                }} 
            />
        </div>
        </header>
    );
};

export default Hero;
